import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import {
    tableDataVM,
    tableFiltersVM,
    tableStateVM,
    tableStatsVM,
    tableViewVM,
} from '../../../core/table/table_view_models';
import {
    splitInvoiceLineItemDispensesTableStateAtom,
    splitInvoiceLineItemDispensesTableViewAtom,
    splitInvoiceLineItemDispensesDataAtom,
    splitInvoiceLineItemDispensesTableStatsAtom,
    splitInvoiceLineItemDispensesTableFiltersAtom,
} from './split_order_invoices_detail_atoms';
import {
    splitInvoiceLineItemDispensesAllColumnsView,
    splitInvoiceLineItemDispensesColumnSpec,
} from './SplitInvoiceLineItemDispensesTableSpec';
import { tblSpecLoadView } from '../../../core/table/tableViewsRepo';
import { ListTableInitHookReturn } from '../../../core/table/table.types';
import { InvoiceLineItemDispensesDataItem } from './split_order_invoices_detail_types';

export const useSplitInvoiceLineItemDispensesTableInit = (): ListTableInitHookReturn => {
    const [init, setInit] = useState(true);
    const setState = useSetImmerAtom(splitInvoiceLineItemDispensesTableStateAtom);
    const setView = useSetImmerAtom(splitInvoiceLineItemDispensesTableViewAtom);
    const setList = useSetImmerAtom(splitInvoiceLineItemDispensesDataAtom);
    const setStats = useSetImmerAtom(splitInvoiceLineItemDispensesTableStatsAtom);
    const setFilter = useSetImmerAtom(splitInvoiceLineItemDispensesTableFiltersAtom);

    useEffect(() => {
        setState(draft => {
            if (init && !draft.waiting) {
                setInit(false);
                const colSpec = splitInvoiceLineItemDispensesColumnSpec();
                const defaultView = splitInvoiceLineItemDispensesAllColumnsView();
                const loadedView = tblSpecLoadView(defaultView.key, [defaultView], colSpec);
                draft.views = [defaultView];
                draft.currentViewId = defaultView.key;
                setView(() => loadedView || tableViewVM());
                return draft;
            }
        });
        /* eslint-disable-next-line */
    }, []);

    useEffect(() => {
        return (): void => {
            setState(() => tableStateVM());
            setView(() => tableViewVM());
            setFilter(() => tableFiltersVM());
            setStats(() => tableStatsVM());
            setList(() => tableDataVM<InvoiceLineItemDispensesDataItem>());
        };
    }, [setFilter, setList, setState, setStats, setView]);

    return { init };
};
